import { flow } from 'fp-ts/function';
import {
    __,
    concat,
    difference,
    dropLast,
    eq,
    every,
    flatMap,
    getOr,
    isEmpty,
    isEqual,
    isNil,
    keyBy,
    map,
    mapValues,
    negate,
    omitBy,
    orderBy,
    propEq,
    reduce,
    reduceRight,
    rest,
    size,
    slice,
    sortBy,
    throttle,
    transform,
    trim,
    uniq,
    zipObject,
} from 'lodash/fp';
import { when } from '@mews/fp';

export const reduceIndexed = (reduce as $TSFixMe).convert({ cap: false });

export const reduceRightIndexed = (reduceRight as $TSFixMe).convert({ cap: false });

export const mapIndexed = (map as $TSFixMe).convert({ cap: false });

export const mapValuesIndexed = (mapValues as $TSFixMe).convert({ cap: false });

export const flatMapIndexed = (flatMap as $TSFixMe).convert({ cap: false });

export const transformIndexed = (transform as $TSFixMe).convert({ cap: false });

export const keyById = keyBy('id');

export const mapId = map('id');

export const mapValue = map('value');

export const getOrEmptyString = getOr('');

export const getOrEmptyArray = getOr([]);

export const getOrEmptyObject = getOr({});

export const getOrFalse = getOr(false);

export const getOrNull = getOr(null);

export const propIsNull = propEq(__, null);

export const propIsNotNull = flow(propIsNull, negate);

export const notEqual = negate(isEqual);

export const notEmpty = negate(isEmpty);

export const notNil = negate(isNil);

export const zipArgs = (keys: $TSFixMe) => rest(zipObject(keys));

export const isTrue = isEqual(true);

export const isFalse = isEqual(false);

export const isObjectOrKeysEmpty = flow(omitBy(flow(trim, isEmpty)), isEmpty);

export const isSizeEqual = (expectedSize: $TSFixMe) => flow(size, eq(expectedSize));

export const isSizeOne = isSizeEqual(1);

export const areAllValuesEqual = flow(uniq, isSizeOne);

export const sortByName = sortBy('name');

export const areAllNil = every(isNil);

export const stubNull = () => null;

export const returnNullWhenEmptyString = when(isEqual(''), stubNull);

export const sortByAscending = <T>(propName: keyof T) => orderBy<T>([propName], ['asc']);
export const sortByDescending = <T>(propName: keyof T) => orderBy<T>([propName], ['desc']);

export const isDifferenceEmpty = flow(difference, isEmpty);

export const createTrueValuesObject = (keys: $TSFixMe) =>
    reduce(
        (accumulator, key) => {
            // @ts-expect-error $TSFixMeError: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{}'.
            accumulator[key] = true;
            return accumulator;
        },
        {},
        keys
    );

export const createKeyedUpdateObject = (keysToCompare: $TSFixMe, keys: $TSFixMe) =>
    reduce(
        (accumulator, key) => {
            // @ts-expect-error $TSFixMeError: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{}'.
            accumulator[key] = { value: keysToCompare.includes(key) };
            return accumulator;
        },
        {},
        keys
    );

export const replaceSubArray = (startIndex: number, newSubArray: $TSFixMe[], sourceArray: $TSFixMe[]) => [
    ...slice(0, startIndex, sourceArray),
    ...dropLast(startIndex + newSubArray.length - sourceArray.length, newSubArray),
    ...slice(startIndex + newSubArray.length, sourceArray.length, sourceArray),
];

export const appendEmptyString = concat(__, '');

export const throttleLeading = (fn: $TSFixMe, timeout = 500) =>
    (throttle as $TSFixMe).convert({ fixed: false })(timeout, fn, { leading: true, trailing: false });
